import React from "react";
import BlogForty from "../component/BlogForty";

function BlogFortyContainer() {
  return <BlogForty />;
}

export default BlogFortyContainer;
